{
  "azure.advisor-recommendation": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.afd-custom-domain": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.afd-endpoint": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.ai-foundry-agent": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.ai-foundry-connection": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.ai-foundry-deployment": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.ai-foundry-project": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.aks": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.alert-logs": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.api-management": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.app-configuration": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.app-insights": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.app-service-environment": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.application-gateway": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.appserviceplan": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.armresource": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "type",
        "headerName": "Type"
      }
    ],
    "id": "id"
  },
  "azure.automation-account": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.backup-vault": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.bastion-host": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.batch": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.budget": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.cdn-custom-domain": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.cdn-endpoint": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.cdnprofile": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.cognitiveservice": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.cognitiveservice-deployment": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.container-group": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.container-registry": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.containerservice": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.cosmosdb": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.databricks": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.datafactory": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.datalake": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.datalake-analytics": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.disk": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.dnszone": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.eventhub": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.eventsubscription": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.front-door": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.front-door-policy": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.hdinsight": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.host-pool": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.image": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.iothub": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.keyvault": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.loadbalancer": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.logic-app-workflow": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.machine-learning-data-container": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.machine-learning-job": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.machine-learning-model-version": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.machine-learning-online-endpoint": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.mariadb": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.mariadb-server": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.monitor-log-profile": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.mysql": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.mysql-flexibleserver": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.networkinterface": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.networksecuritygroup": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.networkwatcher": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.open-shift": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.policyassignments": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.postgresql-database": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.postgresql-flexibleserver": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.postgresql-server": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.private-dns-zone": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.private-record-set": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.publicip": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.recordset": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.recovery-services": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.redis": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.resourcegroup": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.roleassignment": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.roledefinition": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.routetable": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.search": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.service-fabric-cluster": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.service-fabric-cluster-managed": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.servicebus-namespace": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.servicebus-namespace-authrules": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.servicebus-namespace-networkrules": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.session-host": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.signalr": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.snapshot": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.spring-app": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.spring-service-instance": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.sql-database": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.sql-server": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.storage": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.storage-container": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.stream-job": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.subscription": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "subscriptionId"
  },
  "azure.synapse": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.traffic-manager-profile": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.vm": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.vmss": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.vnet": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.waf": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.webapp": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Resource ID"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "resourceGroup",
        "headerName": "Resource Group"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "id"
  },
  "azure.containerregistry": {
    "c7n-alias-for": "azure.container-registry"
  },
  "azure.sqldatabase": {
    "c7n-alias-for": "azure.sql-database"
  },
  "azure.sqlserver": {
    "c7n-alias-for": "azure.sql-server"
  }
}
